import initLandingMedia from './components/landing-media';
import initLandingFAQ from './components/landing-faq';
import сustomPageScroll from './components/custom-scroll';
import {isTouch} from "./helpers/detect-device";
import {BROWSER, IS_PHONE} from "./helpers/consts";
import lineTicker from "./components/line-ticker";
import initScrolllineTicker from "./components/line-scroll-ticker";
import initLanding from "./components/landing";
import initVideo from "./components/video";
import initParallaxSections from "./components/parallax-section";
import initStackableCards from "./components/stackable-content-cards";
import initOrbitCards from "./components/landing-orbit-cards";

window.addEventListener('DOMContentLoaded', () => {
	if (!isTouch()) {
		document.body.classList.add('no-touch');
	}
	else {
		document.body.classList.add('touch');
	}

	if (IS_PHONE) {
		document.body.classList.add('is-phone');
	}
	document.body.classList.add(BROWSER.name);

	// сustomPageScroll.init(); // should be first


	// Initialise Scrolltrigger
	initParallaxSections();


	setTimeout(() => {
		lineTicker();
		initScrolllineTicker();
	}, 2000);

	initVideo();
	initStackableCards();
	initLanding();
	initLandingMedia();
	initLandingFAQ();
	initOrbitCards()

});
